import React from 'react';
import { Upload, CheckCircle } from 'lucide-react';

const CommonFields = ({ reason, setReason, evidenceFile, evidenceUrl, fileInputRef, onFileUpload }) => {
  return (
    <>
      <div>
        <label className="block text-sm text-slate-400 mb-1">Reason for Edit *</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="e.g., Phone damaged, paper diary entry, driver reported..."
          className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white h-20 resize-none"
          data-testid="reason-input"
        />
      </div>

      <div>
        <label className="block text-sm text-slate-400 mb-1">Upload Evidence (optional)</label>
        <div className="flex items-center gap-3">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={onFileUpload}
            className="hidden"
          />
          <button
            onClick={() => fileInputRef.current?.click()}
            className="px-4 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600 flex items-center gap-2"
            data-testid="upload-evidence-btn"
          >
            <Upload className="w-4 h-4" />
            {evidenceFile ? evidenceFile.name : 'Upload Paper Diary Image'}
          </button>
          {evidenceUrl && <CheckCircle className="w-5 h-5 text-emerald-400" />}
        </div>
      </div>
    </>
  );
};

export default CommonFields;
